import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";

let cancelToken;

const costCenterModURL = "api/v1/cost-center/cost-center";

//obtaining the paginated data
export const getCostCenter = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${costCenterModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllCostCenter = () => axiosInstance.get(`${costCenterModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageCostCenter = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${costCenterModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createCostCenter = (body) => axiosInstance.post(`${costCenterModURL}/create`, body);
//updating function
export const updateCostCenter = (id, body) => axiosInstance.patch(`${costCenterModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${costCenterModURL}/list?offset=0&limit=${rowsPerPage} &ordering=${sortOrder} &search=${search}`);

// checking the redundant data
export const checkRedundantDataCostCenterName = (e, cancelToken) =>
  axiosInstance.get(`${costCenterModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
